import React from "react";
import { Modal, Button } from "react-bootstrap";

function BankAccountAchMessage(props) {
  return (
    <Modal
      show={true}
      onHide={() => props.handleShow("BankAccountAchMessage", false)}
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-primary">
          Bank Account Verification
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>Bank account verification needed!</h5>
        <p>
          Before we are able to process any payments with this newly added
          payment method, you will need to verify your bank account.
        </p>
        <p>
          Step 1. Two small deposits are going to be made into your bank account
          by Finpay. This may take 3-4 business days.
        </p>
        <p>
          Step 2. Login into your Bank account. If you see two deposits log in
          into your Finpay account and click on the yellow notification on the
          top.
        </p>
        <p>
          Step 3. Enter the two deposit ammounts on the Bank Account
          Verification screen.
        </p>
        <p>Step 4. Click verify.</p>

        <p>
          And that is all there is to it! You will be able to make payments via
          your newly linked bank account!
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn-warning"
          onClick={() => props.handleShow("BankAccountAchMessage", false)}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default BankAccountAchMessage;



// WEBPACK FOOTER //
// ./src/home/components/bank-account-ach-message.js